import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    
    setStatus('loading');
    setErrorMessage('');

    try {
      const baseUrl = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
      const response = await fetch(`${baseUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      // Capture the EXACT error from the backend
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erreur serveur (HTTP ${response.status})`);
      }

      setStatus('success');
    } catch (err) {
      setErrorMessage(err.message);
      setStatus('error');
    }
  };

  return (
    <div style={{ paddingTop: 'var(--nav-h, 64px)', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5F0E8' }}>
      <div style={{ background: '#fff', border: '1px solid rgba(140,122,106,0.2)', borderRadius: 4, padding: 48, maxWidth: 400, width: '100%', margin: '0 20px' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Mot de passe oublié</h1>
        <p style={{ color: '#8C7A6A', fontSize: 14, marginBottom: 28 }}>Entrez votre adresse email. Si elle correspond à un compte, vous recevrez un lien de réinitialisation.</p>

        {status === 'success' ? (
          <div style={{ padding: '16px', background: 'rgba(76,175,80,.15)', color: '#2E7D32', borderRadius: 4, fontSize: 14, marginBottom: 20 }}>
            ✓ Un email a été envoyé si ce compte existe.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontFamily: 'Space Mono, monospace', fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C7A6A', marginBottom: 6 }}>Email</label>
              <input 
                type="email" 
                value={email} 
                onChange={e => setEmail(e.target.value)} 
                placeholder="vous@exemple.fr"
                style={{ width: '100%', padding: '12px 16px', border: '1px solid rgba(140,122,106,0.3)', borderRadius: 2, fontFamily: 'Familjen Grotesk, sans-serif', fontSize: 15, outline: 'none' }} 
                required
              />
            </div>

            {status === 'error' && (
              <p style={{ color: 'var(--radar-orange)', fontSize: 13, marginBottom: 16 }}>Erreur: {errorMessage}</p>
            )}

            <button 
              type="submit" 
              disabled={status === 'loading'} 
              style={{ width: '100%', padding: '13px', background: 'var(--radar-deep)', color: '#fff', border: 'none', borderRadius: 2, fontFamily: 'Space Mono, monospace', fontSize: 13, letterSpacing: '0.06em', textTransform: 'uppercase', cursor: status === 'loading' ? 'not-allowed' : 'pointer', opacity: status === 'loading' ? 0.7 : 1, marginBottom: 20 }}
            >
              {status === 'loading' ? 'Envoi en cours...' : 'Envoyer le lien →'}
            </button>
          </form>
        )}

        <div style={{ textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#8C7A6A', fontSize: 13, textDecoration: 'none', fontFamily: 'Familjen Grotesk, sans-serif' }}>
            ← Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}